// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    APPLICATION_NAME: "HOME",
    TITLE_PREFIX: "VMANICO",
    HOMEPAGE: "itc-home",
    INDIA_DOMAIN: "https://vmanico.in/",
    USA_DOMAIN: "https://vmanico.com/",
    API_VERSION: "/api/v1",
    IP_API_ENDPOINT: "https://vmanico.com/ip",
    API_TYPE: {
        PUBLIC: "public_api",
        REGISTRATION: "registration_api",
        LOGIN: "login_api",
        AUTHENTICATED: "authenticated_api",
        FORGOT_PASSWORD: "login_forgot_password_api",
        V360: "v360_api",
    },
    V360_APP: 'https://vmanico.com/360',
    SERVICES_APP: 'https://vmanico.com/srvhome',
    AUTH_SERVICE_ENDPOINT: '/homeservice/dev/api/v0.0.01x',
    LOCAL_COOKIE: false,
    WEBCAM: false,
    LOAD_LOCAL_DATA: true,
    SHOW_CHATBOT: false,
    GET_IP_ADDRESS: true,
    DEFAULT_REGION: "USA",
    CONTACT_US_USA: {
        title: "Global Headquarters",
        address: "1 Marina Park Drive <br> UNIT 1410,<br> Boston, MA 02210, USA",
        phone: "+1 857 770 1505",
        email: "contact@vmanico.com",
    },
    CONTACT_US_INDIA: {
        title: "India Headquarters",
        address: "VMANICO Technologies pvt. Ltd.<br> Level 2, Oval Building<br> Plot no.18 iLab's,<br>Hyderabad Technology Park,<br>Inorbit Mall Road,<br>Hyderabad - 500081",
        phone: "+91 9052509995",
        email: "contact@vmanico.in",
    },
    IDLE_LIMIT: 3600, // VALUE IN SECONDS

    DATA_PRODUCTION_PHYSICAL_SECURITY: "physical_security",
    DATA_PRODUCTION_PHYSICAL_SECURITY_URL: "https://aws.amazon.com/compliance/data-center/perimeter-layer/",

    DATA_PRODUCTION_PHYSICAL_SECURITY1: "physical_security",
    DATA_PRODUCTION_PHYSICAL_SECURITY1_URL: "https://aws.amazon.com/compliance/iso-27001-faqs/",

    IP_POLICY_VERSIONS_OF_POLICY: "Privacy-Contact@vmanico.com",
    IP_POLICY_VERSIONS_OF_POLICY_URL: "Privacy-Contact@vmanico.com",

    PRIVACY_USA_WHAT_POWER_YOU_HOLD_OVER_PERSONAL_DATA: "Ever_wondered_what_powers_you_hold_over_your_personal_data?",
    PRIVACY_USA_WHAT_POWER_YOU_HOLD_OVER_PERSONAL_DATA_URL: "Privacy-Contact@vmanico.com",

    PRIVACY_USA_WHAT_POWER_YOU_HOLD_OVER_PERSONAL_DATA_1: "Ever_wondered_what_powers_you_hold_over_your_personal_data?",
    PRIVACY_USA_WHAT_POWER_YOU_HOLD_OVER_PERSONAL_DATA_1_URL: "Privacy-Contact@vmanico.com",

    PRIVACY_INDIA_UPDATE_TO_PERSONAL_INFORMATION: "Amendment_or_update_to_Personal_Information",
    PRIVACY_INDIA_UPDATE_TO_PERSONAL_INFORMATION_URL: "Privacy-Contact@vmanico.in",

    PRIVACY_INDIA_SECURITY_OF_INFORMATION: "SECURITY_OF_INFORMATION",
    PRIVACY_INDIA_SECURITY_OF_INFORMATION_URL: "Privacy-Contact@vmanico.in",

    PRIVACY_INDIA_ADDRESSING_YOUR_CONCERNS: "Addressing_your_concerns",
    PRIVACY_INDIA_ADDRESSING_YOUR_CONCERNS_URL: "Privacy-Contact@vmanico.in",
};

export const timeIntervals = {
    pageLoadTimeOut: 3000, // VALUE IN MILISECONDS
    slideTimeInterval: 20, // VALUE IN SECONDS
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
